export default __webpack_public_path__ + "static/media/logo.97a76c93.png";